import AbstractStore from 'core/abstracts/AbstractStore';
import Dispatcher from 'core/Dispatcher';
import Constants from 'constants.js';

class ControlTowerStore extends AbstractStore {

    constructor() {

        const CHANGE_EVENT = 'CATALOG_CHANGE_EVENT';
        const NAME = 'CATALOG_STORE';

        super(NAME, CHANGE_EVENT);

        this._initStore();

        // Registers action handler with the Dispatcher.
        Dispatcher.register(this._registerToActions.bind(this));
    }

    _initStore() {
        this.loading = true;
        this.catalogs = [];
        this.count = 0;
        this.params = {
            page: 1,
            rowsPerPage: 500,
            site: '',
            account: ''
        };
    }

    isLoading() {
        return this.loading;
    }

    getCatalogs() {
        return this.catalogs;
    }

    getCount() {
        return this.count;
    }

    getParams() {
        return this.params;
    }

    setParams(params) {
        this.params = params;
    }

    setCount(count) {
        this.count = count;
    }

    setCatalogs(catalogs) {
        this.catalogs = catalogs;
    }

    // Switches over the action's type when an action is dispatched.
    _registerToActions(action) {
        switch (action.actionType) {
        case Constants.LOGOUT:
            this._initStore();
            this._emitChange();
            break;
        case Constants.CATALOGS_GET_START:
            this.setParams(action.value);
            this.loading = true;
            this._emitChange();
            break;
        case Constants.CATALOGS_GET_END:
            if (this.params === action.value.params) {
                this.setCatalogs(action.value.sites);
                this.setCount(action.value.count);
                this.loading = false;
                this._emitChange();
            }
            break;
        default:
            return false;
        }
    }

}

export default new ControlTowerStore();
